import { apiSlice } from "../api/apiSlice";

export const quizMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizzesMark: builder.query({
      query: () => `/quizMark`,
    }),
    getQuizMark: builder.query({
      query: (id) => `/quizMark/${id}`,
    }),
    addQuizMark: builder.mutation({
      query: ({ data }) => ({
        url: "/quizMark",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetQuizzesMarkQuery,
  useGetQuizMarkQuery,
  useAddQuizMarkMutation,
} = quizMarkApi;
